import { render } from "./ExpertTypeDetailVx.vue?vue&type=template&id=d1bf331c"
import script from "./ExpertTypeDetailVx.vue?vue&type=script&lang=js"
export * from "./ExpertTypeDetailVx.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\TimSpule\\source\\repos\\peacoq\\Schaltzeit\\ScoutDB\\CisLogic.ScoutDB.UI.Esa\\app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__